import React from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { OFFER_ANCHOR, PRODUCT_ALT, PRODUCT_IMG } from './constants';
export function Hero() {
  return <section className="bg-white px-4 pb-3 pt-4" data-id="element-78" data-mp="9k0fha3kwjqp">
      <div className="mx-auto max-w-3xl text-center" data-id="element-79" data-mp="9ipc3be1pe04">
        <h1 className="mb-2 font-display text-[26px] font-extrabold uppercase leading-[1.02] tracking-tight text-golf-green sm:text-[44px]" data-id="element-80" data-mp="4mrul1r1q1lr">
          The Complete Ready-to-Use System for{' '}
          <span className="text-golf-lime" data-id="element-81" data-mp="xa4ibf8y0fgn">Golf Coaches</span>
        </h1>
        <p className="mx-auto mb-1 max-w-2xl text-[13px] font-medium leading-snug text-golf-muted sm:text-base" data-id="element-82" data-mp="sb1bbp9ejz61">
          Stop spending hours planning lessons, searching for drills, creating practice plans, and
          preparing resources for every golfer.
        </p>
        <p className="mx-auto mb-2 max-w-2xl text-[13px] font-semibold leading-snug text-golf-green sm:text-base" data-id="element-83" data-mp="3czfms3kkof85">
          Everything you need to coach is finally organized in one professional system.
        </p>

        <a href={OFFER_ANCHOR} className="mb-2 block" aria-label="Go to the purchase section" data-id="element-84" data-mp="3o7ls3r2jl6oy">
          <img src={PRODUCT_IMG} alt={PRODUCT_ALT} className="mx-auto w-full max-w-[280px] object-contain drop-shadow-2xl transition-transform duration-200 ease-out hover:scale-[1.02] sm:max-w-sm" data-id="element-85" data-mp="3o59a5dwsawbw" />
        </a>

        <CTAButton className="mx-auto mb-2 max-w-md" data-id="element-86" data-mp="30h9dxygpedpx">🚀 YES! I WANT MY SYSTEM NOW</CTAButton>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-golf-green sm:text-sm" data-id="element-87" data-mp="359ja3w8ewa0n">
          <span className="flex items-center gap-1" data-id="element-88" data-mp="2qi0kr7tnx34m">
            <StarIcon className="h-4 w-4 fill-golf-gold text-golf-gold" aria-hidden="true" data-id="element-89" data-mp="2vjzpal152635" />
            ⭐⭐⭐⭐⭐ 4.9/5 — Verified Customer Reviews
          </span>
          <span className="flex items-center gap-1" data-id="element-90" data-mp="2lkqwhvi0exid">
            <ShieldCheckIcon className="h-4 w-4 text-golf-lime" aria-hidden="true" data-id="element-91" data-mp="2lk8usjckvr32" />
            🛡️ 14-Day Money-Back Guarantee — Zero Risk
          </span>
        </div>
      </div>
    </section>;
}